import React, { useRef, useState, useCallback } from 'react';
import VectorMap from './VectorMap';
import NearbyPanel from './NearbyPanel';
import MapCategoryExplorer from './MapCategoryExplorer';

// Thin wrapper around the live VectorMap. The map renders immediately; this
// wrapper only wires the map's "Atrodi man tuvākos" button to the "Tavā
// tuvumā" results list shown below the map, and the list's "Rādīt kartē"
// action back to the map (fly-to).
export default function MapInstantStart({ height = '100%', 'data-testid': testId = 'map-instant-start', linkToFullMap, ...rest }) {
  const apiRef = useRef(null);
  const explorerRef = useRef(null);
  const mapWrapRef = useRef(null);
  const [nearbyOpen, setNearbyOpen] = useState(false);
  const [userLoc, setUserLoc] = useState(null);

  // Map's own locate button → open the nearby list at the user's location.
  const handleMapLocate = useCallback((loc) => {
    if (!loc) return;
    setUserLoc(loc);
    setNearbyOpen(true);
  }, []);

  // A region category satellite was tapped → focus that category in the
  // explorer below (it fills the list + highlights the pins on the map).
  const handleRegionCategory = useCallback((key) => {
    explorerRef.current?.selectCategory?.(key);
  }, []);

  // A region was opened (centre circle OR satellite) → auto-enable the
  // "only in visible map area" filter so the chips/list reflect that region.
  const handleRegionOpen = useCallback(() => {
    explorerRef.current?.enterRegion?.();
  }, []);

  // "Rādīt kartē" on a nearby card → scroll back up to the map and fly to it.
  const handleOpenOnMap = useCallback((it) => {
    if (!it || it.lat == null || it.lng == null) return;
    mapWrapRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    apiRef.current?.flyTo({ center: [it.lng, it.lat], zoom: 15, duration: 1200 });
  }, []);

  return (
    <>
      <div ref={mapWrapRef} className="relative w-full rounded-2xl overflow-hidden scroll-mt-20" style={{ height }} data-testid={testId}>
        <VectorMap ref={apiRef} height="100%" onLocate={handleMapLocate} onRegionCategory={handleRegionCategory} onRegionOpen={handleRegionOpen} {...rest} />
      </div>

      {/* Browse by category (Veikali / Pakalpojumi / Pasākumi / Projekti /
          Uzņēmumi) — chips + list below the map, with map highlighting. */}
      <MapCategoryExplorer ref={explorerRef} apiRef={apiRef} mapWrapRef={mapWrapRef} />

      {/* "Tavā tuvumā" results — rendered BELOW the map, like the business /
          event result lists (same on mobile and desktop). */}
      <NearbyPanel open={nearbyOpen} onClose={() => setNearbyOpen(false)} userLoc={userLoc} onOpenOnMap={handleOpenOnMap} />
    </>
  );
}
